import React from 'react';
import {Form, Textarea, List} from 'components';
import {useNamedSelector} from 'helpers';

export function PurposeInquiry1() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'purpose-inquiry-1' })}>
      <List tiny-gutter>
        <List.Title>What unique contribution could you make/are you making to the world?</List.Title>
        <Textarea single name="1" />
        <List.Title>What is an important cause that you could get behind?</List.Title>
        <Textarea single name="2" />
        <List.Title>If you had all the money and resources you needed, what is it that you would do to make a difference?</List.Title>
        <Textarea single name="3" />
        <List.Title>What is it that you are here on earth to accomplish? How can you best invest your time and energy?</List.Title>
        <Textarea single name="4" />
        <List.Title>What small thing can you do today to make this a better world?</List.Title>
        <Textarea single name="5" />
        <List.Title>How would you live your life differently if you were immortal?</List.Title>
        <Textarea single name="6" />
        <List.Title>What would you do if you were the leader of your country?</List.Title>
        <Textarea single name="7" />
        <List.Title>What would you do if you were a super hero? How would you utilize your power?</List.Title>
        <Textarea single name="8" />
        <List.Title>Based on your answers above, can you identify and describe your Life Purpose?</List.Title>
        <Textarea single name="9" />
      </List>
    </Form>
  );
}
